import type { IRTSponsorshipSchema } from "~/types/models/RTSponsorship.model";
import type { IRtSponsorship } from "../types";

export const RTSponsorshipSchema2Interface = (
  rtSponsorshipSchema: IRTSponsorshipSchema
): IRtSponsorship => {
  return {
    link: rtSponsorshipSchema.Link,
    imageUrl: rtSponsorshipSchema.Image || "",
    message: rtSponsorshipSchema.Message
  };
};
